import { useQuery } from 'react-query';
import { fetchData } from './fetchData';
import { usePageErrors } from '../components/errors/PageErrorContext';
import { APIError } from './useErrorMessageMapping';
import { useTranslation } from 'react-i18next';

const fetchPersonalizationData = async (api_key: string, personalization_id: string, onSuccessCallback: (data: any) => void, handleError: (error: unknown) => void, t: any): Promise<any> => {
    // Construct the URL dynamically, including the width query parameter
    const url = `/configurator/sessions/personalizations/${personalization_id}`;


    try {
        // Call the fetchData function with the URL and the API key
        const response = await fetchData<any>(url, api_key);
        //console.log('usePersonalizationData Status:', response.status);
        //console.log('usePersonalizationData Headers:', response.headers);
        if (response.status === 200) {
            // Extract filename from headers
            // Read filename from custom header 'x-filename'
            // const fileName = response.headers['x-filename'] || 'personalization.jpg';

            return {
                data: response.data,

            };
        }
        else {
            console.log("usePersonalizationData Else inside try")
            //      alert("Error in downloading production info. Try it again");
            const apiError: APIError[] = [
                { key: "generic", source: "generic", message: t("error.message") }
            ];
            handleError(apiError)
            // Notify parent app to close
            // onSuccessCallback({ command: 'CLOSE' });

            //  Still throw so react-query marks query as failed
            throw new Error(`Error fetching personalization data`);
        }
    } catch (error: any) {
        console.log("catch usePersonalizationData fetchPersonalizationData Error:", error);

        // Show generic alert for 400 / 500, descriptive for others
        if (error.status === 500) {
            //      alert("Error in downloading production info. Try it again");
            const apiError: APIError[] = [
                { key: "generic", source: "generic", message: t("error.message") }
            ];
            handleError(apiError)

        } else {
            console.log("usePersonalizationData inside catch else part")
            handleError(error.data)

        }

        // Notify parent app to close
        // onSuccessCallback({ command: 'CLOSE' });

        //  Still throw so react-query marks query as failed
        throw new Error(`Error fetching personalization data`);
    }
};

export const usePersonalizationData = (api_key: string, personalization_id: string, onSuccessCallback: (data: any) => void) => {
    const { t } = useTranslation()
    const { mapAndSetErrors } = usePageErrors();
    return useQuery(['personalizationData', api_key, personalization_id], () => {
        if (api_key && personalization_id)
            return fetchPersonalizationData(api_key, personalization_id, onSuccessCallback, mapAndSetErrors, t)
        else {
            return null
        }

    }, {
        onError: (err: any) => {

        },
        enabled: !!api_key && !!personalization_id, // Only fetch if api_key and personalization_id are available
        retry: 0, // disable retry
        refetchOnWindowFocus: false,     // no refetch when window refocuses
        refetchOnReconnect: false,       // no refetch when reconnecting network
    });
};